module.exports = __webpack_public_path__ + "img/img17.999cf0cd.png";